import { createNavigation } from 'next-intl/navigation';
import { routing } from './routing';

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);

// This utility function helps with constructing localized URLs
export function constructLocalizedUrl(pathname: string, locale: string) {
  return locale === 'lt' ? pathname : `/${locale}${pathname}`;
} 